


















import { gql } from 'graphql-tag';
import { Component, mixins } from 'nuxt-property-decorator';

import { blockableBlockColorFragment, blockColorMixin } from '@/composables/block-color';

import { WysiwygBlockDataFragment } from '@/graphql/generated';
import { PageBlockMixin } from '@/modules/cms';

@Component({
  graphqlData: gql`
    fragment WysiwygBlockData on WysiwygBlock {
      id
      content
      ...BlockColor
    }

    ${blockableBlockColorFragment}
  `,
})
export default class WysiwygBlock extends mixins(PageBlockMixin<WysiwygBlockDataFragment>(), blockColorMixin) {
  get backgroundColorClass () {
    if (!this.blockColor)
      return null;

    return `bg-${this.blockColor}`;
  }
}
